export default "/images/vendor/flag-icon-css/flags/1x1/au.svg?54426acb27779ea944eaf5aea3548973";